import React from 'react'
import { useHistory } from 'react-router-dom';
import Navbar from './Navbar';
import BannerSection from './BannerSection';
import AboutSection from './AboutSection';
import RatingSection from './RatingSection';
import FeaturesSection from './FeaturesSection';
import AccordionSection from './AccordionSection';
import Footer from './Footer';

export default function Landing() {
  const history = useHistory();
  return (
    <div>
      <Navbar />
      <BannerSection />
      <AboutSection />
      <RatingSection />
      <FeaturesSection />
      <AccordionSection />
      <Footer />
    </div>
  )
}
